import React, { useState, Component, useRef, useEffect } from "react";
import useStyles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Divider, Icon } from "@material-ui/core";
import { Link } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";

//importing files
import {
  addProductToWishlist,
  useWishlistContext,
} from "../../context/WishlistContext";
import { useCartContext, addProductToCart } from "../../context/CartContext";

// MUI Components
import { Grid, Button, Typography } from "@material-ui/core";

export default function ProductDetails() {
  const classes = useStyles();
  const { dispatch, cartProducts } = useCartContext();
  const [wishlistItems, setWishlistItems] = useState([]);
  const { wishlistDispatch, wishlistProducts } = useWishlistContext();
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  useEffect(() => {
    //scroll to the top of page
    window.scrollTo(0, 0);
    if (wishlistProducts != "null" && wishlistProducts != null) {
      setWishlistItems([...wishlistProducts]);
    }
  }, []);

  const deleteWishlistItem = (index) => {
    //for filtering item from wishlist
    let temp = wishlistItems;
    temp = temp.filter((item) => {
      return item._id !== wishlistItems[index]._id;
    });
    setWishlistItems([...temp]);

    //deleting item from local storage
    return addProductToWishlist(wishlistDispatch, temp);
  };
  const clearWishlist = () => {
    if (wishlistItems.length < 1) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: `No Products in wishlist to clear.`,
        open: true,
      });
    }
    setWishlistItems([]);
    localStorage.removeItem("WISHLIST_DATA");
    window.location.reload(false);
  };
  const showOutOfStockSnackBarError = (item) => {
    return setSnackBar({
      ...snackBarstate,
      type: "error",
      message: `Sorry! ${item.title} cannot be added to cart.
      ${
        item.stockAvailable >= 1
          ? `Its available stock is ${item.stockAvailable} i.e. already added in your cart.`
          : `It's out of stock.`
      }`,
      open: true,
    });
  };

  const showAddedToCartSuccessMessage = (productName) => {
    return setSnackBar({
      ...snackBarstate,
      type: "success",
      message: `${productName} successfully added to cart.`,
      open: true,
    });
  };

  const addItemToCart = (item) => {
    let cartItem = item;
    if (cartProducts === "null" || cartProducts === null) {
      if (cartItem.stockAvailable >= 1) {
        window.location.reload(false);
        showAddedToCartSuccessMessage(item.title);
        return addProductToCart(dispatch, [cartItem]);
      } else {
        return showOutOfStockSnackBarError(cartItem);
      }
    } else {
      if (!cartProducts.filter((e) => e._id === cartItem._id).length > 0) {
        if (cartItem.stockAvailable >= 1) {
          let temp = cartProducts;
          temp.push(cartItem);
          window.location.reload(false);
          showAddedToCartSuccessMessage(item.title);
          return addProductToCart(dispatch, temp);
        } else {
          return showOutOfStockSnackBarError(cartItem);
        }
      } else {
        cartProducts.forEach((product) => {
          if (product._id === cartItem._id) {
            if (product.stockAvailable >= product.quantity + 1) {
              product.quantity += 1;
              showAddedToCartSuccessMessage(item.title);
              window.location.reload(false);
            } else {
              return showOutOfStockSnackBarError(cartItem);
            }
          }
        });
        let temp = cartProducts;
        return addProductToCart(dispatch, temp);
      }
      // console.log("cart Products", cartProducts)
    }
  };

  const addAllProductsInCart = () => {
    if (wishlistItems.length < 1) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: `Add Products in wishlist before adding to cart.`,
        open: true,
      });
    }
    let areAllProductsValidToAddInCart = true;
    let isStockOfWishlistProductValid = true;
    let wishListProductIndex = null;
    let cartProductIndex = null;
    wishlistProducts.forEach((wishlistProduct, indexWishList) => {
      if (wishlistProduct.stockAvailable < 1) {
        isStockOfWishlistProductValid = false;
        wishListProductIndex = indexWishList;
        return;
      }
      if (cartProducts) {
        cartProducts.forEach((cartProduct, indexCart) => {
          if (wishlistProduct._id === cartProduct._id) {
            if (cartProduct.stockAvailable < cartProduct.quantity + 1) {
              cartProductIndex = indexCart;
              return (areAllProductsValidToAddInCart = false);
            }
          }
        });
      }
    });

    if (!isStockOfWishlistProductValid) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: `Sorry! ${wishlistProducts[wishListProductIndex].title} is out of stock cannot add it to cart.`,
        open: true,
      });
    }

    if (!areAllProductsValidToAddInCart) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: `Sorry! cannot add ${cartProducts[cartProductIndex].title} to cart. Its available stock is
         ${cartProducts[cartProductIndex].stockAvailable} i.e. already added in your cart.`,
        open: true,
      });
    }

    if (addProductToCart(dispatch, wishlistProducts)) {
      setSnackBar({
        ...snackBarstate,
        type: "success",
        message: `Added all products in cart successfully.`,
        open: true,
      });
      window.location.href = "/cart";
    } else {
      setSnackBar({
        ...snackBarstate,
        type: "error",
        message: `Sorry! Cannot add products in cart.`,
        open: true,
      });
    }
  };

  return (
    <div>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 30, paddingBottom: 15 }}
          aria-label="breadcrumb"
        >
          <Link
            className={classes.bCrumbLink}
            style={{ textDecoration: "none", color: "grey" }}
            color="inherit"
            to="/"
          >
            Home
          </Link>
          <Link
            className={classes.bCrumbLink}
            style={{ textDecoration: "none", color: "grey" }}
            color="inherit"
            to="/account"
          >
            My Account
          </Link>
          <Typography color="textPrimary">Wishlist</Typography>
        </Breadcrumbs>
        <Grid
          container
          style={{ justifyContent: "space-between", display: "flex" }}
        >
          <Grid lg={12} sm={12} style={{ width: "100%" }}>
            <div className={classes.wishlistTitleBox}>
              <Typography
                variant="h5"
                style={{ fontWeight: "bold", letterSpacing: 1, wordSpacing: 4 }}
              >
                WISHLIST
              </Typography>

              <div
                className={classes.wishlistTitleButtonsBox}
                style={{
                  display: wishlistItems.length > 0 ? "flex" : "none",
                }}
              >
                <Typography
                  variant="p"
                  style={{ color: "grey", marginRight: 10 }}
                >
                  Total item (s): {wishlistItems.length}
                </Typography>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.addAllToCartBtn}
                  onClick={addAllProductsInCart}
                >
                  <ShoppingCartIcon style={{ marginRight: 8 }} />
                  Add all to cart
                </Button>
                <Button
                variant="outlined"
                  className={classes.clearWishlistBtn}
                  onClick={() => clearWishlist()}
                >
                  <DeleteOutlinedIcon style={{ marginRight: 3 }} />
                  Clear My Wishlist
                </Button>
              </div>
            </div>
            {/* Mapping wishlist items here */}
            {wishlistItems
              ? wishlistItems.map((item, index) =>
                  React.cloneElement(
                    <div className={classes.WishlistItemBox}>
                      <div className={classes.storeNameBox}>
                        <Typography variant="p" style={{ fontWeight: "bold" }}>
                          {item.storeName}
                        </Typography>
                        <Typography
                          variant="p"
                          style={{ fontSize: 13, color: "#666" }}
                        >
                          {item.category}
                        </Typography>
                      </div>

                      <div className={classes.productDetailsBox}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            className={classes.itemImageBox}
                            src={item.image}
                          />
                          <div className={classes.productDescBox}>
                            <Typography
                              variant="p"
                              noWrap
                              style={{ maxWidth: 300 }}
                            >
                              {item.title}
                            </Typography>
                            <Typography variant="p" style={{ color: "grey" }}>
                              Brand: {item.brand}
                              {item.color ? `, Color: ${item.color}` : null}
                            </Typography>
                            <Typography variant="p" style={{ color: "black" }}>
                              Stock Available: {item.stockAvailable}
                            </Typography>
                          </div>
                        </div>

                        <div className={classes.priceTextBox}>
                          <Typography style={{ color: "black" }}>
                            Price
                          </Typography>
                          <Typography
                            className={classes.priceText}
                            variant="h4"
                          >
                            Rs. {item.price}
                          </Typography>
                          <Typography
                            variant="h6"
                            style={{
                              textDecoration: "line-through",
                              color: "grey",
                            }}
                          >
                            {item.cutPrice ? `Rs. ${item.cutPrice}` : null}
                          </Typography>
                        </div>

                        {/* Price section */}
                        <div className={classes.priceSection}>
                          <Button
                            style={{
                              textAlign: "center",
                              paddingRight: 12,
                              marginTop: 20,
                            }}
                            variant="outlined"
                            onClick={() => deleteWishlistItem(index)}
                          >
                            <DeleteOutlinedIcon />
                            Remove
                          </Button>

                          <Button
                            color="primary"
                            variant="contained"
                            className={classes.addToCartBtn}
                            onClick={() => addItemToCart(item)}
                          >
                            <ShoppingCartIcon style={{ marginRight: 8 }} />
                            Add to cart
                          </Button>
                        </div>
                      </div>
                    </div>,
                    {
                      key: item._id,
                    }
                  )
                )
              : null}
              {
                wishlistItems.length > 0 ? null:<Typography style={{marginTop:10}}>No Products Present in Wishlist.</Typography>
              }
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
